export class CookieHelper {
    get = (key) => {
        var cookie = document.cookie.split(';').find(c => c.trim().toLocaleLowerCase().startsWith(key.trim().toLocaleLowerCase()));

        if (cookie) {
            var value = cookie.split('=')[1];

            return value;
        }
    };
};

const cookie = new CookieHelper();

export default cookie;